module.exports = __webpack_public_path__ + "img/shtg.6cf384f0.png";